import * as service from './service'
export default {
  namespace: 'walletMain',
  state: {
    accountData: {},
    incomeData: {}
  },
  effects: {
    * getAccountData ({ payload }, { call, put }) {
      const res = yield call(service.getAccountData, payload)
      yield put({
        type: 'save',
        payload: {
          accountData: JSON.parse(res.data.data)
        }
      })
      return res.data
    },
    * getIncomeData ({ payload }, { call, put }) {
      const res = yield call(service.getIncomeData, payload)
      yield put({
        type: 'save',
        payload: {
          incomeData: res.data.data
        }
      })
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
